<app-mu-modal-dialog-layout
  [flagList]="flagList"
  [showFlag]="flagEnum.SHOW_MAP_FULLSCREEN"
  [showCloseIcon]="true"
  [fullscreeContent]="true"
  [hideLine]="true"
  (eventCloseDialogModal)="_eventCloseDialogModal()"
>
  <div modalDialogContent class="p-col-12 mu-modal-text mu-without-padding mu-fullHeight">
    <app-mu-map
      [mapOptions]="mapOptionsFullScreen"
      [markers]="markers"
      [class]="'sndMapsFullScreen'"
      (eventSetMap)="setMap($event)"
      (eventComponentReady)="setMapComponent($event)"
    ></app-mu-map>
  </div>
</app-mu-modal-dialog-layout>
